import { AdditionalService } from '@cemex-core/cmx-api';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { AdditionalServicesActionTypes, AdditionalServicesActions } from '../actions/additional-services.actions';

export interface AdditionalServicesState {
  loading: boolean;
  additionalServices: AdditionalService[];
}

export const initialState: AdditionalServicesState = {
  loading: false,
  additionalServices: null,
};

export function additionalServicesReducer(
  state = initialState,
  action: AdditionalServicesActions | OrderBuilderActions,
): AdditionalServicesState {
  switch (action.type) {
    case AdditionalServicesActionTypes.LOAD: {
      return {
        ...state,
        ...initialState,
        loading: true,
      } as AdditionalServicesState;
    }
    case AdditionalServicesActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        additionalServices: action.payload,
      } as AdditionalServicesState;
    }
    case RESET_BUILDER:
    case AdditionalServicesActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
